import Tag from '../../../../components/Display/Tag';
import { CONSTANT } from '../../../../utils/constants';
import { getImage } from '../../../../utils/imageHelper';
import { ButtonGroup } from 'primereact/buttongroup';
import { Button } from 'primereact/button';
import { ChevronUp } from '@primeicons/react/chevron-up';
import { ChevronDown } from '@primeicons/react/chevron-down';

function ProjectItem({ project, handleClickProject, onChange }) {
  return (
    <div className="flex flex-row gap-y-2">
      <div
        className="flex flex-row items-start py-5 px-3 gap-x-5 cursor-pointer hover:bg-slate-100 w-full"
        onClick={handleClickProject}>
        <img
          className="h-32 object-cover shadow-md block rounded-md"
          src={project.main_image?.file ? project.main_image?.file : getImage('img-ph.png')}
          alt={project.main_image?.label ? project.main_image.label : 'Non renseignée'}
        />
        <div className="flex flex-col justify-between h-full">
          <div className="flex flex-col gap-y-1">
            <div className="text-xl font-bold text-slate-700 ">{project.title}</div>
            <span className="font-medium text-slate-700">{project.place_name}</span>
          </div>
          <div className="flex flex-row gap-x-3">
            <Tag
              tag={CONSTANT.prna.statusTypes.find((s) => s.value === project.state)}
              rounded
              className="w-fit"
            />
            <Tag
              tag={{
                label: project.is_highlight && 'Projet mis en avant',
                icon: 'star',
                bgColor: project.is_highlight && 'bg-purple-800'
              }}
              rounded
            />
            <Tag
              tag={{
                label: `${project.circumstances.length} circonstance${project.circumstances.length > 1 ? 's' : ''}`,
                bgColor: 'bg-slate-700'
              }}
              rounded
            />
          </div>
        </div>
      </div>
      <ButtonGroup className="flex flex-col gap-x-2 h-full justify-center items-center">
        <Button
          variant="outlined"
          severity="primary"
          text
          raised
          iconOnly
          className="rounded-full"
          onClick={() => onChange(project, -1)}>
          <ChevronUp />
        </Button>
        <Button
          variant="outlined"
          severity="primary"
          iconOnly
          text
          raised
          className="rounded-full"
          onClick={() => onChange(project, 1)}>
          <ChevronDown />
        </Button>
      </ButtonGroup>
    </div>
  );
}

export default ProjectItem;
